import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EMPTY_RICH_TEXT_DOCUMENT, } from "@diality/contracts";
import { cn } from "../lib/utils";
import { RichTextDocumentView } from "./rich-text";
import { PAGE_GUTTER, Section } from "./_section";
/**
 * The opening statement itself, without block chrome — so a component harness
 * renders exactly what a page renders.
 *
 * Two columns above 900px: the title opens the page on the left, the
 * supporting copy sits beside it rather than under it, which is what keeps a
 * long opening statement from pushing the rest of the page off screen. Below
 * that they stack.
 *
 * The title is a real `<h1>`: this is what opens the page, and a page-opening
 * hero whose title is ordinary text leaves the page with nothing to navigate
 * by. The description is the shared {@link RichTextDocumentView}, so a document
 * composed for a Rich Text block reads identically here.
 */
export function TextHeroView({ data }) {
    return (_jsxs("div", { className: cn("grid grid-cols-1 gap-12", "@min-[901px]:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] @min-[901px]:gap-14", "@min-[1101px]:grid-cols-[minmax(0,510px)_minmax(0,510px)] @min-[1101px]:justify-between @min-[1101px]:gap-[clamp(64px,7cqw,100px)]"), children: [_jsxs("div", { className: "flex flex-col items-start gap-[18px] @min-[901px]:gap-[22px]", children: [_jsx("p", { "data-text-hero-eyebrow": true, className: "type-eyebrow-lg font-bold", children: data.eyebrow }), _jsx("h1", { "data-text-hero-title": true, className: "max-w-[620px] text-balance font-display text-[clamp(52px,15cqw,68px)] font-light leading-[1.04] tracking-[-0.02em] text-brand-blue @min-[901px]:max-w-[510px] @min-[901px]:text-[clamp(64px,7.5cqw,82px)] @min-[1101px]:text-[clamp(72px,6.667cqw,96px)]", children: data.title })] }), _jsx("div", { "data-text-hero-description": true, children: _jsx(RichTextDocumentView, { document: data.description, className: "flex max-w-[680px] flex-col gap-5 font-body text-[18px] font-light leading-[1.55] text-pretty [&_p]:my-0 [&_p]:leading-[1.55] [&_strong]:font-bold @min-[901px]:max-w-[510px] @min-[901px]:gap-6 @min-[901px]:pt-1 @min-[901px]:text-[20px]" }) })] }));
}
export function TextHeroBlock({ data }) {
    return (_jsx(Section, { tone: "default", className: PAGE_GUTTER, children: _jsx(TextHeroView, { data: data }) }));
}
export function textHeroFromBlock(block, _resolve) {
    const scalars = block.scalars ?? {};
    return {
        eyebrow: scalars.eyebrow ?? "",
        title: scalars.title ?? "",
        description: block.documents?.description ?? EMPTY_RICH_TEXT_DOCUMENT,
    };
}
export const textHeroBlockEntry = {
    Component: TextHeroBlock,
    fromBlock: textHeroFromBlock,
};
//# sourceMappingURL=text-hero.js.map